import { render, staticRenderFns } from "./ContactsInfoForTripPointInfo.vue?vue&type=template&id=cb3d2a36&functional=true&"
import script from "./ContactsInfoForTripPointInfo.vue?vue&type=script&lang=js&"
export * from "./ContactsInfoForTripPointInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
